module.exports = __webpack_public_path__ + "DINNextLTPro-Italic.woff2?9411b18ccbba64b82946ad905b406b8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Italic.woff2
// module id = 1403
// module chunks = 0